import React from 'react';
import useMedicalProfiles from '../../../hooks/api/useMedicalProfiles';
import SharedProfilesHeader from './SharedProfilesHeader';

export type SelectedProfilesHeaderOwnProps = {
    selectedProfileIds: string[];
};

export type SelectedProfilesHeaderProps = SelectedProfilesHeaderOwnProps;

const SelectedProfilesHeader: React.FC<SelectedProfilesHeaderProps> = (props) => {
    const { medicalProfiles, collaboratorMedicalProfiles, isLoadingProfiles } = useMedicalProfiles();

    return (
        <SharedProfilesHeader
            {...props}
            profiles={[...medicalProfiles, ...collaboratorMedicalProfiles]}
            isLoadingProfiles={isLoadingProfiles}
        />
    );
};

export default React.memo(SelectedProfilesHeader);
